module.exports = __webpack_public_path__ + "img/devices_black.586f8e36.svg";